// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import OrderChangeState from "@store/Framework/Store/Greif/Pages/OrderChange/OrderChangeState";
import { OrderChangeRequestNewLineModel, OrderChangeRequestModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: OrderChangeState = {
    newLines: [] as OrderChangeRequestNewLineModel[],
    changeRequestOrder: { probability: 9 } as OrderChangeRequestModel,
    isSubmitting: false,
    requestSubmitted: false,
    failedToSubmitRequest: false,
    errorMessage: undefined,
};

const actions = {
    "Greif/Pages/OrderChange/SetChangeRequestOrder": (
        draft: Draft<OrderChangeState>,
        action: { changeRequestOrder: OrderChangeRequestModel },
    ) => {
        draft.changeRequestOrder = action.changeRequestOrder;
    },
    "Greif/Pages/OrderChange/UpdateChangeRequestOrder": (
        draft: Draft<OrderChangeState>,
        action: { changeRequestOrder: Partial<OrderChangeRequestModel> },
    ) => {
        draft.changeRequestOrder = { ...draft.changeRequestOrder, ...action.changeRequestOrder };
    },
    "Greif/Pages/OrderChange/UpdateNewLines": (
        draft: Draft<OrderChangeState>,
        action: { newLines: OrderChangeRequestNewLineModel[] },
    ) => {
        draft.newLines = action.newLines;
    },
    "Greif/Pages/OrderChange/BeginSubmitRequest": (draft: Draft<OrderChangeState>) => {
        draft.isSubmitting = true;
    },
    "Greif/Pages/OrderChange/FailedToSubmitRequest": (
        draft: Draft<OrderChangeState>,
        action: { errorMessage: string | undefined },
    ) => {
        draft.isSubmitting = false;
        draft.failedToSubmitRequest = true;
        draft.errorMessage = action.errorMessage;
    },
    "Greif/Pages/OrderChange/CompleteSubmitRequest": (draft: Draft<OrderChangeState>) => {
        draft.isSubmitting = false;
        draft.requestSubmitted = true;
    },
    "Greif/Pages/OrderChange/ClearChangeRequestOrder": (draft: Draft<OrderChangeState>) => {
        draft.changeRequestOrder = initialState.changeRequestOrder;
        draft.isSubmitting = initialState.isSubmitting;
        draft.requestSubmitted = initialState.requestSubmitted;
        draft.failedToSubmitRequest = initialState.failedToSubmitRequest;
        draft.errorMessage = initialState.errorMessage;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifOrderChangePagesActions = Parameters<typeof reducer>[1];
export default reducer;
